import React, { Component } from "react";
import {form, ff, Loader, HorizontalLoader} from "@mc/mc-legacy";
import { Button, CardBody, Card } from "reactstrap";
import { FormErrors, reduxForm } from "redux-form";
import SpravaUctuApi from "../api/gen/core/SpravaUctuApi";
import CardTitle from "../components/layout/CardTitle";
import ReCaptcha from "react-google-recaptcha";
import ReCaptchaApi from "../api/gen/core/ReCaptchaApi";
import { withLang } from "../i18n/withLang";
import { i18n } from "../i18n/i18n";
import { EospPageContent } from "../components/layout/EospPageContent";
import "./ResetPasswordPage.scss";
import {brandTitle} from "../i18n/Message";

type FormData = {
  login: string;
  captcha: string;
};

class ResetPassword extends Component<any> {
  state = {
    reCaptchaSiteKey: null,
    captchaAllowed: true,
  };

  componentDidMount() {
    ReCaptchaApi.getReCaptchaSiteKey().then((reCaptchaSiteKey) =>
      this.setState({
        reCaptchaSiteKey,
      })
    );
  }

  static validate = (data, props) => {
    const errors: FormErrors<FormData> = {};

    if (!data.login) {
      errors.login = i18n(props.lang, "ResetPasswordForm_login_required");
    }

    if (!data.captcha) {
      errors.captcha = i18n(props.lang, "ResetPasswordForm_captcha_required");
    }

    return errors;
  };

  render() {
    const { handleSubmit, error, submitting } = this.props;
    const { reCaptchaSiteKey, captchaAllowed } = this.state;
    const disabledCaptchaLoading = captchaAllowed && !reCaptchaSiteKey;
    return (
      <form.Form horiznotal onSubmit={handleSubmit}>
        <form.FormBody>
          {error && <form.ValidationErrors error={error} />}
          <ff.String
            className={"py-15"}
            disabled={submitting || disabledCaptchaLoading}
            placeholder={i18n(this.props.lang, "ResetPasswordForm_login")}
            label={false}
            name="login"
            required
          />
          <p>{i18n(this.props.lang, "ResetPasswordForm_info")}</p>
          {captchaAllowed && reCaptchaSiteKey ? (
            <ff.Base
              key={"capt" + this.props.lang}
              componentClass={ReCaptcha}
              name={"captcha"}
              label={false}
              className={"mt-2 text-right"}
              hl={this.props.lang}
              sitekey={reCaptchaSiteKey}
              required
            />
          ) : (
            captchaAllowed && <Loader />
          )}
        </form.FormBody>
        <form.FormActions submitting={submitting} submitButton={false}>
          <Button className={"btn btn-primary py-15"} disabled={submitting || disabledCaptchaLoading}>
              {i18n(this.props.lang, "ResetPasswordForm_button_obnovitHeslo")}
              {submitting && <HorizontalLoader />}
          </Button>
        </form.FormActions>
      </form.Form>
    );
  }
}

const ResetPasswordForm = withLang(
  reduxForm<FormData, any>({
    form: "newPassword",
    validate: ResetPassword.validate,
  })(ResetPassword)
);
/**
 * Stránka pro umožnění resetu zapomenutého hesla.
 */

class ResetPasswordPage extends React.Component<any> {
  state = {
    done: false,
  };

  render() {
    const { done } = this.state;

    const title = brandTitle(this.props.lang);
    return (
      <EospPageContent className={"reset-password-page"}>
        <CardTitle title={title} >
          <h4 className={"font-weight-bold mb-4 sub-title"}>
              {i18n(this.props.lang, "ResetPasswordPage_obnoveniHesla")}
          </h4>
        </CardTitle>
        {!done && (
          <ResetPasswordForm
            onSubmit={({ login, captcha }) => SpravaUctuApi.resetovatHeslo({ login: login, captcha: captcha })}
            onSubmitSuccess={() => this.setState({ done: true })}
          />
        )}
        {done && (
          <div>
            <p>{i18n(this.props.lang, "ResetPasswordPage_done")}</p>
          </div>
        )}
      </EospPageContent>
    );
  }
}

export default withLang(ResetPasswordPage);
